import { render, staticRenderFns } from "./ColunaAcoes.vue?vue&type=template&id=3806c72f&class=coluna&"
import script from "./ColunaAcoes.vue?vue&type=script&lang=js&"
export * from "./ColunaAcoes.vue?vue&type=script&lang=js&"
import style0 from "./ColunaAcoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports